import React from 'react';
const Phone = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.473 6.367c1.975.496 3.518 1.936 4.05 3.78M13.879 8.438c1.185.297 2.111 1.161 2.43 2.267" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
      <path clip-rule="evenodd" d="M9.398 12.04c.654 1.248 1.737 2.254 3.076 2.858.2.088.433.072.616-.044l1.972-1.227a.669.669 0 0 1 .598-.05l3.688 1.475c.258.102.412.35.378.61-.241 1.76-1.848 3.08-3.75 3.08-5.915 0-10.71-4.475-10.71-9.995 0-1.776 1.414-3.275 3.301-3.5a.636.636 0 0 1 .654.352l1.582 3.446a.554.554 0 0 1-.052.553l-1.31 1.869a.55.55 0 0 0-.043.573z" stroke="#000" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Phone;
